import React, { useEffect } from 'react';
import { ArrowLeftIcon, MapPinIcon, CalendarIcon, UsersIcon, TrendingUpIcon, LeafIcon, HeartIcon, ShareIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function HabitatDetails() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const habitatData = {
    name: 'Ashridge Estate Woodland Restoration',
    location: 'Ashridge Estate, Hertfordshire',
    description: 'A comprehensive habitat restoration project focused on protecting endangered dormouse populations and restoring native woodland ecosystems.',
    totalDonors: 1842,
    totalRaised: 128750,
    userContribution: 75,
    startDate: 'January 2024',
    completionDate: 'March 2024',
    achievements: ['15 hectares of woodland restored', '8 dormouse nests discovered', '200+ native trees planted', 'Habitat monitoring system installed']
  };
  const handleArrangeVisit = () => {
    window.open('https://www.nationaltrust.org.uk/visit/essex-bedfordshire-hertfordshire/ashridge-estate', '_blank');
  };
  return <div className="min-h-screen bg-background dark:bg-gray-900" data-id="element-1225">
      <div className="max-w-4xl mx-auto px-4 py-8" data-id="element-1226">
        {/* Back button */}
        <button onClick={() => navigate('/')} className="flex items-center text-text-secondary dark:text-gray-400 hover:text-primary dark:hover:text-primary mb-6 transition-colors" data-id="element-1227">
          <ArrowLeftIcon className="w-5 h-5 mr-2" data-id="element-1228" />
          <span data-id="element-1229">Back to Dashboard</span>
        </button>
        {/* Hero image */}
        <div className="relative h-64 md:h-96 rounded-2xl overflow-hidden mb-8" data-id="element-1230">
          <img src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&q=80" alt="Ashridge Estate" className="w-full h-full object-cover" data-id="element-1231" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-1232" />
          <div className="absolute bottom-6 left-6 right-6" data-id="element-1233">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-1234">
              {habitatData.name}
            </h1>
            <div className="flex items-center text-white/90 mb-4" data-id="element-1235">
              <MapPinIcon className="w-5 h-5 mr-2" data-id="element-1236" />
              <span data-id="element-1237">{habitatData.location}</span>
            </div>
            <button onClick={handleArrangeVisit} className="bg-white text-primary px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors inline-flex items-center" data-id="element-1238">
              <CalendarIcon className="w-5 h-5 mr-2" data-id="element-1239" />
              Arrange a Visit
            </button>
          </div>
        </div>
        {/* Thank you card */}
        <div className="bg-gradient-to-r from-primary/10 to-secondary/10 dark:from-primary/20 dark:to-secondary/20 rounded-xl p-6 mb-8 border border-primary/20" data-id="element-1240">
          <div className="flex items-start" data-id="element-1241">
            <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1242">
              <HeartIcon className="w-6 h-6 text-primary" data-id="element-1243" />
            </div>
            <div data-id="element-1244">
              <h2 className="text-xl font-bold text-text-primary dark:text-white mb-2" data-id="element-1245">
                Thank You for Your Contribution!
              </h2>
              <p className="text-text-secondary dark:text-gray-300" data-id="element-1246">
                Your donation of £{habitatData.userContribution} has directly
                contributed to the protection and restoration of this vital
                habitat. Together with{' '}
                {habitatData.totalDonors.toLocaleString()} other donors, you
                have made a real difference to wildlife conservation.
              </p>
            </div>
          </div>
        </div>
        {/* Stats grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-1247">
          <div className="bg-card dark:bg-gray-800 rounded-xl p-6 border border-gray-100 dark:border-gray-700" data-id="element-1248">
            <div className="flex items-center mb-2" data-id="element-1249">
              <UsersIcon className="w-5 h-5 text-primary mr-2" data-id="element-1250" />
              <h3 className="font-semibold text-text-primary dark:text-white" data-id="element-1251">
                Total Donors
              </h3>
            </div>
            <p className="text-3xl font-bold text-text-primary dark:text-white" data-id="element-1252">
              {habitatData.totalDonors.toLocaleString()}
            </p>
            <p className="text-sm text-text-muted dark:text-gray-400 mt-1" data-id="element-1253">
              Community members
            </p>
          </div>
          <div className="bg-card dark:bg-gray-800 rounded-xl p-6 border border-gray-100 dark:border-gray-700" data-id="element-1254">
            <div className="flex items-center mb-2" data-id="element-1255">
              <TrendingUpIcon className="w-5 h-5 text-secondary mr-2" data-id="element-1256" />
              <h3 className="font-semibold text-text-primary dark:text-white" data-id="element-1257">
                Total Raised
              </h3>
            </div>
            <p className="text-3xl font-bold text-text-primary dark:text-white" data-id="element-1258">
              £{habitatData.totalRaised.toLocaleString()}
            </p>
            <p className="text-sm text-text-muted dark:text-gray-400 mt-1" data-id="element-1259">
              Funding secured
            </p>
          </div>
          <div className="bg-card dark:bg-gray-800 rounded-xl p-6 border border-gray-100 dark:border-gray-700" data-id="element-1260">
            <div className="flex items-center mb-2" data-id="element-1261">
              <HeartIcon className="w-5 h-5 text-primary mr-2" data-id="element-1262" />
              <h3 className="font-semibold text-text-primary dark:text-white" data-id="element-1263">
                Your Impact
              </h3>
            </div>
            <p className="text-3xl font-bold text-text-primary dark:text-white" data-id="element-1264">
              £{habitatData.userContribution}
            </p>
            <p className="text-sm text-text-muted dark:text-gray-400 mt-1" data-id="element-1265">
              Your contribution
            </p>
          </div>
        </div>
        {/* Project details */}
        <div className="bg-card dark:bg-gray-800 rounded-xl p-6 mb-8 border border-gray-100 dark:border-gray-700" data-id="element-1266">
          <h2 className="text-xl font-bold text-text-primary dark:text-white mb-4" data-id="element-1267">
            About This Project
          </h2>
          <p className="text-text-secondary dark:text-gray-300 mb-6" data-id="element-1268">
            {habitatData.description}
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-1269">
            <div data-id="element-1270">
              <p className="text-sm text-text-muted dark:text-gray-400 mb-1" data-id="element-1271">
                Project Start
              </p>
              <p className="font-semibold text-text-primary dark:text-white" data-id="element-1272">
                {habitatData.startDate}
              </p>
            </div>
            <div data-id="element-1273">
              <p className="text-sm text-text-muted dark:text-gray-400 mb-1" data-id="element-1274">
                Completion Date
              </p>
              <p className="font-semibold text-text-primary dark:text-white" data-id="element-1275">
                {habitatData.completionDate}
              </p>
            </div>
          </div>
          <h3 className="font-semibold text-text-primary dark:text-white mb-3" data-id="element-1276">
            Key Achievements
          </h3>
          <div className="space-y-2" data-id="element-1277">
            {habitatData.achievements.map((achievement, index) => <div key={index} className="flex items-start" data-id="element-1278">
                <LeafIcon className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1279" />
                <p className="text-text-secondary dark:text-gray-300" data-id="element-1280">
                  {achievement}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}